<div class="workSpace">
  <div class="headersTab w3-container w3-container-template">
    <div class="w3-caja-menu padreizquierda">
      <div class="w3-thirty w3-row hijoizquierda centradoVertical">
        <span class="w3-text-deep-orange w3-margin-right-filter w3-tituloPrincipal"> <b> {{
                'menu.'+dataService.moduleSelect | translate }} </b></span>
        <span class="w3-text-deep-orange">&bull;</span>
        <span class="w3-text-orange w3-margin-left-filter w3-subtituloPrincipal"> {{
            'menu.'+dataService.subModuleSelect | translate }} </span>
      </div>
      <!-- Filtros -->
      <div class="w3-rest w3-caja-menu padreizquierda">
        <!-- Filtro de Períodos -->
        <div class="w3-veinte">
          <app-filters [name]="'filtros.per' | translate" [array]="Periodos" [typeFilter]="Filters.PERIOD" [click]="true" (eventClick)="cambioPeriodo($event)"></app-filters>
        </div>                
        <!-- Filtro de Escenarios -->
        <div class="w3-quarter">
          <app-filters [name]="'proyFinanciera.escenarioProyeccion.escenario' | translate"
            [array]="escenarios" [typeFilter]="Filters.ESCENARIOS" [click]="false"
            (eventClick)="escenarioChange($event)">
          </app-filters>
        </div>
        <!-- Filtro de Sucursales -->
        <div class="w3-half" style="margin-left: 2vh; height: 6.5vh; padding-top: 1.2%;">
          <div class="w3-veinte">
            <button class="w3-button w3-right" [matMenuTriggerFor]="menuSuc">
              {{ 'filtros.sucursales'+tagInstitucion | translate }}
              <mat-icon class="iconoMen">expand_more</mat-icon>
            </button>
            <mat-menu class="w3-medium" #menuSuc="matMenu">
              @for (suc of sucursales; track $index) {
                <button mat-menu-item (click)="sucursalChange(suc); $event.stopPropagation();">
                  <div class="w3-row" style="width: 9vw !important;">
                    <div class="w3-quarter" style="padding-top: 3px;">
                      <input type="checkbox" style="cursor: pointer;"
                      [checked]="suc.check"/>
                    </div>
                    <div class="w3-rest textoOverFlow">
                      <span>{{suc.name}}</span>
                    </div>
                  </div>
                </button>
              }
            </mat-menu>
          </div>
          <div class="w3-rest" style="margin-top: 5px">
            <div class="w3-row containerChips2">
              <div class="chips2 nombres2">
                <div class="autoAjuste2">
                  @for (suc of sucursales; track $index) {
                    <div [ngClass]="{
                      'w3-round-btn-large grisBtn w3-center w3-elemento-menu w3-button':suc.check,
                      'w3-hide':!suc.check}" class="filtroMesAnioSeleccionado2">
                      <span style="margin-left: 5px;">{{suc.name}}</span>
                    </div>
                  }
                </div>
              </div>
              @if (numPerSelect()) {
                <div class="tresPuntos2">
                  <mat-icon [ngStyle]="{'color':'gray'}" class="iconoClos w3-button"
                  [matMenuTriggerFor]="menuDesplegable">more_horiz</mat-icon>
                  <mat-menu #menuDesplegable="matMenu" xPosition="before">
                    @for (suc of sucursales; track $index) {
                      <div  [ngClass]="{
                      'w3-round-btn-large grisBtn w3-center w3-elemento-menu w3-button':suc.check,
                      'w3-hide':!suc.check}" class="filtroMesAnioSeleccionado2">
                        <span style="margin-left: 5px;">{{suc.name}}</span>
                      </div>
                    }
                  </mat-menu>
                </div>
              }
            </div>
          </div>
        </div>        
        <!--Borrar filtros-->
        <div class="w3-rest padreizquierda">
          <div class="w3-row hijoizquierda w3-right">
            <div class="w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}"
              (click)="resetFilters()" style="transform: scale(0.9);" matTooltip="{{'tooltips.borrar-filtros'|translate}}">
                <img src="./../../../../assets/img/eraser.png">
            </div>
          </div>
        </div>
      </div>   
      <!-- FIN Filtros -->
    </div>
  </div>    

  <!-- Tablero -->
  <div class="workSpaceTab">
    <div class="zona1 w3-row">
      <div class="w3-row w3-header-cuadrante">
        <div class="w3-half hijoizquierdaTitle w3-titulo-contenidomenu">
          <span class="w3-margin-left-contenido">{{ cuentaSelect?.name }}</span>
          <span class="w3-punto-subtitulo w3-margin-left-filter">&bull;</span>
          <span class=" w3-margin-left-filter w3-subtitulo">{{ periodoSeleccionado?.nombre}} | {{ escenarioSeleccionado?.name }}</span>
        </div>
        <div class="w3-quarter"> 
          <app-filters [name]="'filtros.cuentas' | translate" [array]="dataCuentas" [original]="dataCuentas" [typeFilter]="Filters.BUSQUEDA" 
            [click]="false" (eventClick)="cambiarCuenta($event)"/>
        </div>
        <div class="w3-rest w3-right">
          @if(grafTab1){
            <mat-icon class="w3-button iconoMen" [ngStyle]="{'color':'gray'}" 
              (click)="grafCuenta.showLabels= !grafCuenta.showLabels" [matTooltip]="grafCuenta.showLabels ? ('graf.desactivar'|translate) : ('graf.activar' | translate)">
              {{ grafCuenta.showLabels ? 'label_off' : 'label'}}
            </mat-icon>
            <mat-icon class="w3-button w3-dropdown-click iconoMen" [ngStyle]="{'color':'gray'}"
                (click)="ampliarGraf(1)" matTooltip="{{'tooltips.tooltipIcono2'|translate}}">
                zoom_out_map
            </mat-icon>  
          }          
          <mat-icon class="w3-button w3-margin-right-contenido" [ngStyle]="{'color':'gray', 'cursor': 'pointer'}"
              [matMenuTriggerFor]="opcionesGraf" matTooltip="Más opciones">
              more_vert
          </mat-icon>
          <mat-menu #opcionesGraf="matMenu">
            <button class="mat-menu-item" mat-menu-item [matMenuTriggerFor]="tipoGrafica">
              <mat-icon class="material-icons-outlined" [ngStyle]="{'color':'gray'}">insert_chart</mat-icon>
              <span>{{'graf.graficas' | translate}}</span>
            </button> 
            @if(grafTab1){
              <button class="mat-menu-item" mat-menu-item (click)="grafTab1=false;">
                <mat-icon class="material-icons-outlined" [ngStyle]="{'color':'gray'}">table</mat-icon>
                <span>{{'graf.tabla'|translate}}</span>
              </button> 
              <button class="mat-menu-item" mat-menu-item (click)="exportarTabla(0)">
                <mat-icon class="material-icons-outlined" [ngStyle]="{'color':'gray'}">image</mat-icon>
                <span>{{'menu.Exportar'|translate}}</span>
              </button> 
            }@else {
              <button class="mat-menu-item" mat-menu-item (click)="exportarGrafica(0)">
                <mat-icon class="material-icons-outlined" [ngStyle]="{'color':'gray'}">image</mat-icon>
                <span>{{'menu.Exportar'|translate}}</span>
              </button>   
            }     
            
          </mat-menu>
          <!-- Submenu de tipos de gráfica -->
          <mat-menu #tipoGrafica="matMenu">
            <button class="mat-menu-item" mat-menu-item 
                [ngClass]="{'w3-disabled': grafCuenta.tipo === typeGrap.COMBO && grafTab1}"
                [disabled]="grafCuenta.tipo === typeGrap.COMBO && grafTab1"
                (click)="cambiarTipoGrafica('COMBO',1)">'
                <mat-icon class="material-icons-outlined" [ngStyle]="{'color':'gray'}">bar_chart</mat-icon>
                <span>{{'credito.concentracion.tipografica'|translate}}</span>
            </button>
            <button class="mat-menu-item" mat-menu-item 
                [ngClass]="{'w3-disabled': grafCuenta.tipo === typeGrap.BAR && grafTab1}"
                [disabled]="grafCuenta.tipo === typeGrap.BAR && grafTab1"
                (click)="cambiarTipoGrafica('BAR',1)">
                <mat-icon class="material-icons-outlined" [ngStyle]="{'color':'gray'}">bar_chart</mat-icon>
                <span>{{'graf.barras'|translate}}</span>
            </button>
            <button class="mat-menu-item" mat-menu-item 
                [ngClass]="{'w3-disabled': grafCuenta.tipo === typeGrap.LINE && grafTab1}"
                [disabled]="grafCuenta.tipo === typeGrap.LINE && grafTab1"
                (click)="cambiarTipoGrafica('LINE',1)">
                <mat-icon class="material-icons-outlined" [ngStyle]="{'color':'gray'}">show_chart</mat-icon>
                <span>{{'graf.lineal'|translate}}</span>
            </button>
            <button class="mat-menu-item" mat-menu-item 
                [ngClass]="{'w3-disabled': grafCuenta.tipo === typeGrap.AREA && grafTab1}"
                [disabled]="grafCuenta.tipo === typeGrap.AREA && grafTab1"
                (click)="cambiarTipoGrafica('AREA',1)">
                <mat-icon class="material-icons-outlined" [ngStyle]="{'color':'gray'}">area_chart</mat-icon>
                <span>{{'graf.area'|translate}}</span>
            </button>                  
          </mat-menu>
        </div>
      </div>
      <div class="grafica">
        @if(grafTab1){
          @if (grafCuenta.data.length > 0) {
            <app-graficador
              [data]="grafCuenta.data"
              [labels]="grafCuenta.etiquetas"
              [type]="grafCuenta.tipo"
              [colors]="coloresGraf2"
              [axisY]="['% cumplimiento', 'Ejecutado real']"
              [axisX]="'segPresupuestal.analisisSegmento.sucursal'+tagInstitucion | translate"
              [zona]="1"
              [legend]="{enabled: true, position: 'bottom'}"
              [etiquetas]="grafCuenta.showLabels"
              [setTwoLast]="true"
              [animations]="true"
              >
            </app-graficador>
          }@else {<app-skeleton-grafica />}  
        }@else {
          <table class="w3-table">
            <thead>
              <tr class="w3-table-title w3-center">
                <th class="w3-border-right-balance marginsH stikyColumBlanco">{{'segPresupuestal.analisisSucursales.titTab1' | translate}}</th>
                <th class="w3-border-right-balance marginsH stikyColumBlanco">{{'segPresupuestal.analisisSucursales.titTab2' | translate}}</th>
                <th class="w3-border-right-balance marginsH stikyColumBlanco">{{'segPresupuestal.analisisSucursales.titTab3' | translate}}</th>
                <th class="w3-border-right-balance marginsH stikyColumBlanco">{{'segPresupuestal.analisisSucursales.titTab4' | translate}}</th>
              </tr>
              
            </thead>
            <tbody>
              @for(suc of grafCuenta.etiquetas; track suc; let i = $index){
                <tr class="w3-table-trtd">
                  <td class="borderAllLow marginsH alinLeft">{{ suc }} {{i}}</td>
                  <td class="borderAllLow marginsH alinRight">{{ formatoMoneda(grafCuenta.data[1].data[i]) }}</td>
                  <td class="borderAllLow marginsH alinRight">{{ formatoMoneda(grafCuenta.data[2].data[i]) }}</td>
                  <td class="borderAllLow marginsH w3-center">{{ formatoPorcentaje(grafCuenta.data[0].data[i]) }}</td>
                </tr>
              }
            </tbody>
          </table>
        }        
      </div>
    </div>
    <div class="zona2 w3-row">
      <div class="w3-row w3-header-cuadrante">
        <div class="w3-half hijoizquierdaTitle w3-titulo-contenidomenu">
          <span class="w3-margin-left-contenido">{{ indSelect?.name }}</span>
          <span class="w3-punto-subtitulo w3-margin-left-filter">&bull;</span>
          <span class=" w3-margin-left-filter w3-subtitulo">{{ periodoSeleccionado?.nombre}} | {{ escenarioSeleccionado?.name }}</span>
        </div>
        <div class="w3-quarter"> 
          <app-filters [name]="'filtros.ind' | translate" [array]="dataIndicadores" [typeFilter]="Filters.INDICADORES" 
            [click]="false" (eventClick)="cambiarIndicador($event)"/>
        </div>
        <div class="w3-rest w3-right">
          @if(grafTab2){
            <mat-icon class="w3-button iconoMen" [ngStyle]="{'color':'gray'}" 
              (click)="grafIndicador.showLabels= !grafIndicador.showLabels" [matTooltip]="grafIndicador.showLabels ? ('graf.desactivar'|translate) : ('graf.activar' | translate)">
              {{ grafIndicador.showLabels ? 'label_off' : 'label'}}
            </mat-icon>
            <mat-icon class="w3-button w3-dropdown-click iconoMen" [ngStyle]="{'color':'gray'}"
                (click)="ampliarGraf(2)" matTooltip="{{'tooltips.tooltipIcono2'|translate}}">
                zoom_out_map
            </mat-icon>  
          }          
          <mat-icon class="w3-button w3-margin-right-contenido" [ngStyle]="{'color':'gray', 'cursor': 'pointer'}"
              [matMenuTriggerFor]="opcionesGraf2" matTooltip="Más opciones">
              more_vert
          </mat-icon>
          <mat-menu #opcionesGraf2="matMenu">
            <button class="mat-menu-item" mat-menu-item [matMenuTriggerFor]="tipoGrafica2">
              <mat-icon class="material-icons-outlined" [ngStyle]="{'color':'gray'}">insert_chart</mat-icon>
              <span>{{'graf.graficas' | translate}}</span>
            </button> 
            @if(grafTab2){
              <button class="mat-menu-item" mat-menu-item (click)="grafTab2=false;">
                <mat-icon class="material-icons-outlined" [ngStyle]="{'color':'gray'}">table</mat-icon>
                <span>{{'graf.tabla'|translate}}</span>
              </button> 
              <button class="mat-menu-item" mat-menu-item (click)="exportarTabla(1)">
                <mat-icon class="material-icons-outlined" [ngStyle]="{'color':'gray'}">image</mat-icon>
                <span>{{'menu.Exportar'|translate}}</span>
              </button> 
            }@else {
              <button class="mat-menu-item" mat-menu-item (click)="exportarGrafica(1)">
                <mat-icon class="material-icons-outlined" [ngStyle]="{'color':'gray'}">image</mat-icon>
                <span>{{'menu.Exportar'|translate}}</span>
              </button> 
            }
          </mat-menu>
          <!-- Submenu de tipos de gráfica -->
          <mat-menu #tipoGrafica2="matMenu">
            <button class="mat-menu-item" mat-menu-item 
                [ngClass]="{'w3-disabled': grafIndicador.tipo === typeGrap.COMBO && grafTab2}"
                [disabled]="grafIndicador.tipo === typeGrap.COMBO && grafTab2"
                (click)="cambiarTipoGrafica('COMBO',2)">'
                <mat-icon class="material-icons-outlined" [ngStyle]="{'color':'gray'}">bar_chart</mat-icon>
                <span>{{'credito.concentracion.tipografica'|translate}}</span>
            </button>
            <button class="mat-menu-item" mat-menu-item 
                [ngClass]="{'w3-disabled': grafIndicador.tipo === typeGrap.BAR && grafTab2}"
                [disabled]="grafIndicador.tipo === typeGrap.BAR && grafTab2"
                (click)="cambiarTipoGrafica('BAR',2)">
                <mat-icon class="material-icons-outlined" [ngStyle]="{'color':'gray'}">bar_chart</mat-icon>
                <span>{{'graf.barras'|translate}}</span>
            </button>
            <button class="mat-menu-item" mat-menu-item 
                [ngClass]="{'w3-disabled': grafIndicador.tipo === typeGrap.LINE && grafTab2}"
                [disabled]="grafIndicador.tipo === typeGrap.LINE && grafTab2"
                (click)="cambiarTipoGrafica('LINE',2)">
                <mat-icon class="material-icons-outlined" [ngStyle]="{'color':'gray'}">show_chart</mat-icon>
                <span>{{'graf.lineal'|translate}}</span>
            </button>
            <button class="mat-menu-item" mat-menu-item 
                [ngClass]="{'w3-disabled': grafIndicador.tipo === typeGrap.AREA && grafTab2}"
                [disabled]="grafIndicador.tipo === typeGrap.AREA && grafTab2"
                (click)="cambiarTipoGrafica('AREA',2)">
                <mat-icon class="material-icons-outlined" [ngStyle]="{'color':'gray'}">area_chart</mat-icon>
                <span>{{'graf.area'|translate}}</span>
            </button>                  
          </mat-menu>
        </div>
      </div>
      <div class="grafica">
        @if(grafTab2){
          @if (grafIndicador.data.length > 0) {
            <app-graficador
              [data]="grafIndicador.data"
              [labels]="grafIndicador.etiquetas"
              [type]="grafIndicador.tipo"
              [colors]="coloresGraf2"
              [axisY]="['Variacion','Ejecutado real']"
              [axisX]="'segPresupuestal.analisisSegmento.sucursal'+tagInstitucion | translate"
              [zona]="2"
              [legend]="{enabled: true, position: 'bottom'}"
              [etiquetas]="grafIndicador.showLabels"
              [setTwoLast]="true"
              [animations]="true"
              [stroke]="true"
              >
            </app-graficador>
          }@else {<app-skeleton-grafica />}
        }@else {
          <table class="w3-table">
            <thead>
              <tr class="w3-table-title w3-center">
                <th class="w3-border-right-balance marginsH stikyColumBlanco">{{'segPresupuestal.analisisSucursales.titTab1' | translate}}</th>
                <th class="w3-border-right-balance marginsH stikyColumBlanco">{{'segPresupuestal.analisisSucursales.titTab2' | translate}}</th>
                <th class="w3-border-right-balance marginsH stikyColumBlanco">{{'segPresupuestal.analisisSucursales.titTab3' | translate}}</th>
                <th class="w3-border-right-balance marginsH stikyColumBlanco">{{'segPresupuestal.analisisSucursales.titTab5' | translate}}</th>
              </tr>              
            </thead>
            <tbody>
              @for(suc of grafIndicador.etiquetas; track suc; let i = $index){
                <tr class="w3-table-trtd">
                  <td class="borderAllLow marginsH alinLeft">{{ suc }} {{i}}</td>
                  <td class="borderAllLow marginsH alinRight">{{ formatoMoneda(grafIndicador.data[1].data[i]) }}</td>
                  <td class="borderAllLow marginsH alinRight">{{ formatoMoneda(grafIndicador.data[2].data[i]) }}</td>
                  <td class="borderAllLow marginsH w3-center">{{ formatoPorcentaje(grafIndicador.data[0].data[i]) }}</td>
                </tr>
              }
            </tbody>
          </table>
        }
      </div>
    </div>
  </div>
</div>

<app-modal [isOpen]="modalOpen" (close)="modalOpen = !modalOpen">
  <div modal-header>
    <div class="w3-row w3-white" style="width: 70vw;">
      <!--Titulo grafica modal-->
      <div class="w3-row w3-half w3-white">
        <div class="w3-row w3-header-cuadrante padreizquierda" style="height: 6vh; margin-top: 10px; margin-left: 20px">
          <div class="w3-noventa2 w3-titulo-contenidomenu  hijoizquierdaTitle">
            <span class="w3-margin-left-contenido">{{tituloModal}} </span>
            <span class="w3-punto-subtitulo w3-margin-left-filter">&bull;</span>
            <span class=" w3-margin-left-filter w3-subtitulo">{{ periodoSeleccionado?.nombre }}</span>
          </div>
        </div>
      </div>
      <!--cerrar modal-->
      <div class="w3-rest w3-right w3-white" style="height: 6vh;">
        <div class="w3-row" style="height: 3vh; transform: translate(0, 40%);">
          @if (graficaAmp === 1) {
            <mat-icon fontSet="material-icons-outlined" class="w3-margin-right-contenido w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}"
            (click)="grafCuenta.showLabels = !grafCuenta.showLabels" matTooltip="{{'financiero.razonesFinancieras.tooltipIcono0'|translate}}">
              {{ grafCuenta.showLabels ? 'label_off' : 'label' }}
            </mat-icon>
          }
          @if (graficaAmp === 2) {
            <mat-icon fontSet="material-icons-outlined" class="w3-margin-right-contenido w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}"
            (click)="grafIndicador.showLabels= !grafIndicador.showLabels" matTooltip="{{'financiero.razonesFinancieras.tooltipIcono0'|translate}}">
              {{ grafIndicador.showLabels ? 'label_off' : 'label' }}
            </mat-icon>
          }
          <!-- Icono exportar -->
          <mat-icon class="w3-margin-right-contenido w3-button" [ngStyle]="{'color':'gray'}"
            (click)="exportarGrafica(graficaAmp)" matTooltip="{{'menu.Exportar'|translate}}">
            image
          </mat-icon>
        </div>
      </div>
    </div>
  </div>
  <div modal-body>
    <!--area grafica-->
    <div style="width: 70vw;" >
      <div class="w3-row contentGraf">
        @if (modalOpen) {
          @if(graficaAmp === 1){
            <app-graficador 
              [data]="grafCuenta.data"
              [labels]="grafCuenta.etiquetas"
              [type]="grafCuenta.tipo"
              [colors]="coloresGraf2"
              [axisY]="['% cumplimiento','%']"
              [axisX]="'Sucursales'"
              [zona]="3"
              [legend]="{enabled: true, position: 'bottom'}"
              [etiquetas]="grafCuenta.showLabels"
              [setTwoLast]="true"
              [animations]="true">
            </app-graficador>
          }
          @if(graficaAmp === 2){
            <app-graficador 
              [data]="grafIndicador.data"
              [labels]="grafIndicador.etiquetas"
              [type]="grafIndicador.tipo"
              [colors]="coloresGraf2"
              [axisY]="['Meta', '%']"
              [axisX]="'Sucursales'"
              [zona]="4"
              [legend]="{enabled: true, position: 'bottom'}"
              [etiquetas]="grafIndicador.showLabels"
              [setTwoLast]="true"
              [animations]="true"
              [stroke]="true">
            </app-graficador>
          }
        }
      </div>
    </div>
  </div>

</app-modal>
